module.exports = __webpack_public_path__ + "assets/images/icons/icon_vaccine-orange.svg?v=1d26e95d";